/* eslint-disable no-console */
const biApi = require('services/api/beautyInsider');
const profileApi = require('services/api/profile');
const actions = require('Actions');
const store = require('Store');
const ProfileActions = require('actions/ProfileActions');
const anaConsts = require('analytics/constants');
const processEvent = require('analytics/processEvent');
const { UPDATE_BEAUTY_PREFERENCE } = require('constants/actionTypes/user');
const Storage = require('utils/localStorage/Storage');
const LOCAL_STORAGE = require('utils/localStorage/Constants');
const {
    SET_COLOR_IQ,
    SET_INITIAL_BEAUTY_PREFERENCES,
    SET_MULTIPLE_BEAUTY_PREFERENCES,
    CLEAR_BEAUTY_PREFERENCE,
    SET_EXPANDED_PREFERENCE,
    SET_PROFILE_COMPLETION_PERCENTAGE
} = require('constants/actionTypes/beautyPreferences');
const { profileCategories } = require('constants/beautyPreferences');
const {
    calculateProfileCompletionStatus,
    mapNotSureNoPreferenceWithBIValues,
    mapNotSureNoPreferenceToStateValues
} = require('utils/BeautyPreferences');

function setColorIQ(colorIQ) {
    return {
        type: SET_COLOR_IQ,
        payload: { colorIQ }
    };
}

function setInitialBeautyPreferences(initialData) {
    const initialDataWithStateValues = mapNotSureNoPreferenceToStateValues(initialData);

    return {
        type: SET_INITIAL_BEAUTY_PREFERENCES,
        initialData: initialDataWithStateValues,
        profileCompletionPercentage: calculateProfileCompletionStatus(initialDataWithStateValues)
    };
}

function setMultipleBeautyPreferences(category, selectedProfiles) {
    return {
        type: SET_MULTIPLE_BEAUTY_PREFERENCES,
        category,
        selectedProfiles
    };
}

function clearBeautyPreference(category) {
    return {
        type: CLEAR_BEAUTY_PREFERENCE,
        category
    };
}

function setExpandedPreference(expandedPreference) {
    return {
        type: SET_EXPANDED_PREFERENCE,
        expandedPreference
    };
}

function setProfileCompletionPercentage(profileCompletionPercentage) {
    return {
        type: SET_PROFILE_COMPLETION_PERCENTAGE,
        profileCompletionPercentage
    };
}

function updateBeautyPreferences(category, profileId, profileData, beautyPreferences) {
    const beautyPreferencesForApi = {
        ...beautyPreferences,
        [category.type]: profileData
    };

    const personalizedInformation = mapNotSureNoPreferenceWithBIValues(beautyPreferencesForApi);

    const data = {
        biAccount: {
            personalizedInformation
        },
        profileId
    };

    return dispatch =>
        profileApi.updateBeautyPreferences(data).then(() =>
            dispatch(
                biApi.getBiProfile(profileId).then(() => {
                    dispatch(setMultipleBeautyPreferences(category.type, profileData));
                    dispatch(setProfileCompletionPercentage(calculateProfileCompletionStatus(beautyPreferencesForApi)));
                    const userData = Storage.local.getItem(LOCAL_STORAGE.USER_DATA, false, false, true);

                    if (userData?.data?.beautyPreference) {
                        userData.data.beautyPreference = beautyPreferencesForApi;
                        Storage.local.setItem(LOCAL_STORAGE.USER_DATA, userData.data, userData.expiry);
                    }
                })
            )
        );
}

const updateBeautyPreference = data => ({
    type: UPDATE_BEAUTY_PREFERENCE,
    payload: data
});

function fireAnalytics(type, isLastPref, isAccordionClick, buttonType, nextCatType) {
    const { BEAUTY_PREFERENCES, MY_SEPHORA } = anaConsts.PAGE_NAMES;
    const actionInfo = {
        skipButton: `${MY_SEPHORA}:skip:${type}`,
        saveButton: isAccordionClick ? '' : `${MY_SEPHORA}:${isLastPref ? 'save' : 'save&continue'}:${type}`
    };

    const processType = isAccordionClick ? anaConsts.ASYNC_PAGE_LOAD : anaConsts.LINK_TRACKING_EVENT;
    const categoryName = profileCategories.find(item => item.type === nextCatType)?.name;
    const pageDetail = isAccordionClick || nextCatType ? 'accordion' : BEAUTY_PREFERENCES;

    const data = {
        pageName: `${MY_SEPHORA}:accordion:${nextCatType ? categoryName : type}:*`,
        actionInfo: actionInfo[buttonType],
        linkName: 'D=c55',
        pageType: MY_SEPHORA,
        pageDetail,
        world: nextCatType ? categoryName : type
    };

    if (buttonType && !isAccordionClick) {
        const pageName = `${MY_SEPHORA}:accordion:${type}:*`;
        digitalData.page.attributes.previousPageData.linkData = actionInfo[buttonType];
        digitalData.page.attributes.sephoraPageInfo.pageName = pageName;

        processEvent.process(anaConsts.ASYNC_PAGE_LOAD, {
            data
        });
    }

    if (isAccordionClick) {
        return processEvent.process(processType, {
            data: {
                ...data,
                pageName: `${MY_SEPHORA}:accordion:${type}:*`,
                world: type
            }
        });
    } else {
        return null;
    }
}

function fireAnalyticsDataOverwrites(overwrites = {}, isPageLoad = false) {
    // with isPageLoad=true fires s.t call and isPageLoad=false fires s.tl call
    const processType = isPageLoad ? anaConsts.ASYNC_PAGE_LOAD : anaConsts.LINK_TRACKING_EVENT;

    return processEvent.process(processType, {
        data: overwrites
    });
}

const openShadeFinderModal = () => actions.showWizard(true, undefined, 'BeautyPreferences');

const openRegisterBIModal = () => actions.showBiRegisterModal({ isOpen: true });

const openPrivacySettingsModal = (title, beautyPrefs, socialProfile, saveProfileCallback) =>
    ProfileActions.showEditFlowModal(true, title, 2, beautyPrefs, socialProfile, saveProfileCallback);

const closePrivacySettingsModal = (profileData, callback) => {
    store.dispatch(ProfileActions.updateBiAccount(profileData.biPrivate, callback));
};

module.exports = {
    updateBeautyPreferences,
    clearBeautyPreference,
    setMultipleBeautyPreferences,
    setColorIQ,
    fireAnalytics,
    fireAnalyticsDataOverwrites,
    openShadeFinderModal,
    updateBeautyPreference,
    setExpandedPreference,
    setInitialBeautyPreferences,
    openRegisterBIModal,
    openPrivacySettingsModal,
    closePrivacySettingsModal,
    setProfileCompletionPercentage
};
